
























import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'

import RowButtonView from '../../../../../../../components/NodeButtonsView/RowButtonView.vue'
import NodeMessagePreview from '../../../../../../../components/SampleNodeComponents/NodeMessagePreview.vue'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import ProxySendMessageAction from '../../../logic/Proxy/actions/ProxySendMessageAction'
import { SendMessageNode } from '../../../logic/SendMessageNode'

@Component({
  components: {
    NodeMessagePreview,
    RowButtonView,
  },
})
export default class SendMessageActionSample extends Vue {
  @Prop() action!: ProxySendMessageAction

  @Prop() i18n!: i18n

  @Prop() node!: SendMessageNode

  @Prop() bindSocket!: DirectiveBinding

  @Prop() editor!: CustomEditor
}
